export const REQUEST_TIMEOUT_MS = 9000

export async function request (url, { method = 'GET', params, headers = {}, body } = {}) {
  let href = url
  if (params) {
    const query = new URLSearchParams()
    Object.keys(params).forEach(key => {
      if (params[key] != null) query.set(key, params[key])
    })
    const qs = query.toString()
    if (qs) href += (url.includes('?') ? '&' : '?') + qs
  }

  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), REQUEST_TIMEOUT_MS)

  try {
    const res = await fetch(href, {
      method,
      headers: {
        Accept: 'application/json',
        ...(body != null ? { 'Content-Type': 'application/json' } : {}),
        ...headers
      },
      body: body != null ? JSON.stringify(body) : undefined,
      signal: controller.signal
    })

    if (!res.ok) {
      const error = new Error(`Request failed with status ${res.status}`)
      error.status = res.status
      throw error
    }

    const text = await res.text()
    return text ? JSON.parse(text) : null
  } finally {
    clearTimeout(timeoutId)
  }
}

export function createClient (baseURL, defaultHeaders = {}) {
  const join = (path) => `${String(baseURL || '').replace(/\/$/, '')}${path}`
  return {
    get (path, options = {}) {
      return request(join(path), {
        ...options,
        method: 'GET',
        headers: { ...defaultHeaders, ...options.headers }
      }).then(data => ({ data }))
    },
    post (path, body, options = {}) {
      return request(join(path), {
        ...options,
        method: 'POST',
        body,
        headers: { ...defaultHeaders, ...options.headers }
      }).then(data => ({ data }))
    }
  }
}
